import React from 'react';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Col, Row, Typography } from 'antd';
import { MobileForm } from './MobileForm';

const FormExtendedWeb = ({ data, columns = 1, formStyle = {} }) => {
  const pages = Array.isArray(data?.extendedFormData) ? data.extendedFormData : [];

  return (
    <>
      {pages?.map((page) => {
        const key = page?._id;
        const label = page?.label || '';
        const pageFields = page?.fields ?? [];

        return (
          <div key={key}>
            {label ? (
              <Row>
                {!formStyle.hidePageIcons ? (
                  <Col md={1}>
                    <FeatherIcon
                      icon="file-text"
                      className="iconTitle"
                      style={{ color: formStyle.pageTitlesColor }}
                      size={25}
                    />
                  </Col>
                ) : null}
                <Col md={22}>
                  <Typography.Title
                    level={5}
                    className="title"
                    style={{ margin: '2px', color: formStyle.pageTitlesColor }}
                  >
                    {label}
                  </Typography.Title>
                </Col>
              </Row>
            ) : null}
            <Row>
              <Col md={24}>
                <div style={{ margin: formStyle?.containerMargin }}>
                  <MobileForm fields={pageFields} readOnly columns={columns} />
                </div>
              </Col>
            </Row>
          </div>
        );
      })}
    </>
  );
};

export default FormExtendedWeb;

FormExtendedWeb.propTypes = {
  data: PropTypes.object,
  columns: PropTypes.number,
  formStyle: PropTypes.shape({
    containerMargin: PropTypes.number,
    hidePageIcons: PropTypes.bool,
    pageTitlesColor: PropTypes.string,
  }),
};
